<template lang="html">

    <section class="banner-categorias">

        <div class="scroll-container row-start">
            <article class="acceso-categoria row-center" :cat="key" v-for="(cat,key) in categorias">
                <router-link class="enlace-cover" :to="$t('enlaces.categoria')+'/'+key"></router-link>
                <div class="contenido column-center">
                    <h2 class="row-center">{{cat}}</h2>
                    <router-link class="btn-skull" :to="$t('enlaces.categoria')+'/'+key">Ver todo</router-link>
                </div>
            </article>
        </div>

    </section>

</template>

<script lang="js">

    import { mapGetters } from 'vuex';

    export default {
        name: 'banner-categorias',
        computed: {
            ...mapGetters({
                categorias: 'getCategorias'
            })
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/parts/banner-categorias.vue